import { composeErrors } from '@ynap/form-utils';
import collateLoginErrors from '../LoginForm/collateErrors';
import collateRegistrationErrors from '../RegistrationForm/collateErrors';

export default function collateErrors(values, props, json) {
    const { messages } = props;

    if (json && json.errors) {
        let errors = {};

        if (values.hasAccount === 'true') {
            let { logonId, _error, ...rest } = collateLoginErrors({ logonId: values.logonId, ...values.login }, { loginSectionName: 'login', ...props }, json);
            errors.logonId = logonId;
            errors._error = _error;
            errors.login = rest;
        } else {
            let { logonId, _error, ...rest } = collateRegistrationErrors(
                { logonId: values.logonId, ...values.registration },
                { registrationSectionName: 'registration', ...props },
                json,
            );
            errors.logonId = logonId;
            errors._error = _error;
            errors.registration = rest;
        }

        return errors;
    }

    return { _error: messages.errors.global() };
}
